export const composition = [
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
    { name: "Sir", designation: "Teacher", membership: "Assistant Professor " },
];